import React, { CSSProperties, ReactNode } from 'react';
import noDataFound from '@fabric-ui/icons/svg/emptyStates/No Data Found.svg';
import { flex } from '@fabric-ui/theme';
import { emptyObject } from '@fabric-ui/utils';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';

interface NoDataFoundProps {
  img?: any;
  imgStyle?: CSSProperties;
  headline?: string;
  callToAction?: ReactNode;
  size?: 'large' | 'medium' | 'small' | 'responsive';
  style?: any;
}

const NoDataFound: React.FC<NoDataFoundProps> = ({
  img = noDataFound,
  imgStyle = { width: 430, height: 320 } as CSSProperties,
  headline = 'No Data Found',
  size = 'responsive',
  callToAction,
  style = emptyObject,
}) => (
  <Box sx={emptyStateStyle(size, style)}>
    <img style={imgStyle} src={img} alt="No data found" />
    <Typography variant={size === 'small' ? 'h5' : 'h3'}>{headline}</Typography>
    {callToAction && <Typography variant="h6">{callToAction}</Typography>}
  </Box>
);

export { NoDataFound };

const emptyStateStyle = (size: string, style: any) => ({
  ...flex.colCenter,
  textAlign: 'center',
  gap: '5px',
  flexGrow: 1,
  height: '100%',
  paddingBottom: '20px',
  img: {
    marginBottom: '20px',
    height: 'unset',
    aspect: size === 'responsive' ? 1 : 'unset',
  },
  h3: {
    fontSize: '18px',
    marginBottom: 1,
    ...style.titleStyle,
  },
  h5: {
    ...style.titleStyle,
  },
  h6: {
    ...flex.row,
    whiteSpace: 'pre',
    color: 'var(--color-content-base-tertiary)',
  },
  ...style.containerStyle,
});
